export const maskedElement = (elem) => {
  if (!elem) return "-";
  const str = elem.toString().replace(/\s+/g, "");
  return `XXXX-XXXX-${str.slice(-4)}`;
};
